import React from 'react';
import * as _ from 'lodash';

import InfinityScrollLoad from '../../InfinityScrollLoad';
import { UserService } from '../../../services/Users';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { TrashIcon } from '../../icons/TrashIcon';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { FormDropdownRadio } from '../../CommonFormComponents';

export class AgencyUserCandidatesDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userCandidates: [],
      userCandidatesAllLoaded: false,
      userCandidatesLoading: false,
      userCandidatesTotal: null,
      usersPage: 0,
      opened: false,
      condition: {
        name: '',
      },
      loaded: false,
      selected: null, // 選択協力会社情報(id)
      selectedName: '', // 選択協力会社情報(name)
      temporarySelected: null, // 選択協力会社情報temp(id)
      temporarySelectedName: '', // 選択協力会社情報temp(id)
    };

    // ユニークID生成(InfinityScrollLoad.jsx用)
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;

    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleInview = this.handleInview.bind(this);
    this.resetState = this.resetState.bind(this);
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
    this._isMounted = false; // componentがunmountされた後、非同期処理のsetStateが実行されないための対策。良い対策ではありません

    this.getUserCandidates = this.getUserCandidates.bind(this);
    this.setCondition = this.setCondition.bind(this);
  }

  resetState = callback => {
    this.setState(
      {
        selected: null,
        selectedName: '',
        temporarySelected: null,
        temporarySelectedName: '',
      },
      callback
    );
  };

  getUserCandidates = (condition = { name: '' }, reset = false) => {
    const { partnerCompanyId } = this.props;
    const prevCandidates = _.cloneDeep(this.state.userCandidates);
    this.setState(
      {
        userCandidates: reset ? [] : prevCandidates,
        userCandidatesLoading: true,
      },
      () => {
        const params = {
          selected_partner_company_id: partnerCompanyId,
          selected_field_id: null,
          name: condition.name,
          limit: REQUEST_PARAMS.parentLimit,
          offset: reset ? 0 : this.state.usersPage * REQUEST_PARAMS.parentLimit,
          isQuiet: true,
        };
        UserService.agencyUserCandidates(params).then(response => {
          if (response.result === false) {
            alert('error: response.result === false');
            return;
          } else {
            // 検索の場合一覧をリセットする
            const { user_lists } = response.data.entities;
            const userCandidatesAllLoaded = user_lists.length < params.limit;
            const userCandidates =
              reset === true ? user_lists : _.cloneDeep(prevCandidates);

            if (reset !== true) {
              const retrievedUserCandidates = _.assign(
                response.data.entities.user_lists
              );
              _.each(retrievedUserCandidates, user => {
                if (_.findIndex(userCandidates, { id: user.id }) < 0) {
                  userCandidates.push(user);
                }
              });
            }
            this.setState({
              userCandidates,
              userCandidatesAllLoaded,
              userCandidatesLoading: false,
              userCandidatesTotal: response.data.total,
              usersPage: reset ? 1 : this.state.usersPage + 1,
            });
          }
        });
      }
    );
  };

  setUserCandidateCondition = condition => {
    this.setState({ condition }, () => {
      this.getUserCandidates(condition, true);
    });
  };

  componentDidMount() {
    this._isMounted = true;
    this.getUserCandidates();

    const candidate = this.props.userCandidatesSelected[this.props.index];
    this.setState({
      selected: candidate.id,
      selectedName: candidate.display_user_fullname,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.state.opened === true) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }

    // 項目が変更された場合更新する
    if (
      !_.isEqual(
        prevProps.userCandidatesSelected,
        this.props.userCandidatesSelected
      )
    ) {
      this.resetState(() => {
        const candidate = this.props.userCandidatesSelected[this.props.index];
        this.setState({
          selected: candidate.id,
          selectedName: candidate.display_user_fullname,
        });
      });
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this._isMounted && this.setState({ opened: false });
  };

  handleOpen = () => {
    // 初期化
    let { opened, selected, selectedName } = { ...this.state };
    if (opened === false) {
      // プルダウンを表示した際、temporarySelectedに選択済みのidを入れる
      this.setState({
        opened: true,
        loaded: true,
        temporarySelected: selected,
        temporarySelectedName: selectedName,
      });
    } else {
      this.setState({ opened: false });
    }
  };

  setCondition = events => {
    const condition = _.cloneDeep(this.state.condition);
    condition.name = events.target.value;
    this.setState({ condition });

    clearTimeout(this.searchTimer);
    if (events) {
      this.searchTimer = setTimeout(() => {
        this.setUserCandidateCondition(condition);
      }, 1000);
    }
  };

  handleInview() {
    if (!this.state.userCandidatesAllLoaded) {
      this.getUserCandidates(this.state.condition);
    }
  }

  handleSelectedRow = (id, checked) => {
    let { temporarySelected, temporarySelectedName } = { ...this.state };
    if (checked === true) {
      temporarySelected = id;
      const selectedRow = _.find(this.state.userCandidates, option => {
        return option.id === id;
      });
      // 選択した職種の名前をtempへ
      temporarySelectedName = selectedRow.display_user_fullname;
    } else {
      temporarySelected = null;
      temporarySelectedName = '';
    }

    this.setState(
      {
        temporarySelected,
        temporarySelectedName,
      },
      () => {
        this.setValue();
      }
    );
  };

  setValue = () => {
    let { selected, selectedName } = { ...this.state };
    // temp情報をselect~に入れる
    selected = this.state.temporarySelected;
    selectedName = this.state.temporarySelectedName;
    const selectedRow = _.find(this.state.userCandidates, option => {
      return option.id === selected;
    });

    this.setState(
      {
        selected,
        selectedName,
        opened: false,
      },
      () => {
        this.props.onSelectUserCandidate(this.props.index, selectedRow);
      }
    );
  };

  render() {
    const getName = () => {
      let name = '管理者を選択';
      const option = _.find(this.props.userCandidatesSelected, {
        id: this.state.selected,
      });
      if (!_.isUndefined(option)) {
        name = option.display_user_fullname;
      } else {
        name = this.state.selectedName || name;
      }
      return name;
    };

    const { userCandidatesSelected, index } = this.props;

    return (
      <div className='agency_user_candidates_item'>
        <div className='dropdown-multi-select'>
          {this.props.readOnly ? (
            <input
              disabled
              type='text'
              value={userCandidatesSelected[index].display_user_fullname}
            />
          ) : (
            <div ref={this.parent}>
              <div
                className={`dropdown-multi-select__header ${
                  this.state.opened ? 'show' : ''
                }`}
              >
                <div
                  id='form-dropdown-btn'
                  href=''
                  className='dropdown-select'
                  onClick={this.handleOpen}
                >
                  <span className='dropdown-select__txt'>{getName()}</span>
                </div>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        onChange={this.setCondition}
                        defaultValue={this.state.condition.name}
                      />
                    </div>
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                      >
                        <ul className='single-select'>
                          {_.map(
                            this.state.userCandidates,
                            (candidate, index) => (
                              <FormDropdownRadio
                                key={index}
                                option={candidate}
                                checked={
                                  this.state.temporarySelected === candidate.id
                                }
                                targetId={this.id}
                                handleSelectedRow={this.handleSelectedRow}
                                forId='agency-company-candidate'
                              >
                                {candidate.display_user_fullname}
                              </FormDropdownRadio>
                            )
                          )}
                          <InfinityScrollLoad
                            targetId={this.targetId}
                            total={this.state.userCandidatesTotal}
                            isLoading={this.state.userCandidatesLoading}
                            callback={this.handleInview}
                            ignoreIndicator={true}
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {this.props.index !== 0 && (
          <button
            className='btn-icon--xs sys-delete form-list__element--btn_delete'
            onClick={() => {
              this.props.onDeleteUserCandidate(this.props.index);
            }}
          >
            <TrashIcon className='icon--2_4x form-list__trash-icon' />
          </button>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/AgencyUserCandidates.jsx